import { PieChart, ShoppingBasketIcon } from "lucide-react";

export function LinkedSipEmptyStateIcon() {
  return (
    <div className="size-14 text-muted-foreground relative">
      <ShoppingBasketIcon strokeWidth={1} className="size-14" />
      <PieChart className="size-6 bg-background z-2 absolute bottom-0 right-0" />
    </div>
  );
}
